const DEFAULT_DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  month: "numeric",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZone: "UTC",
});

export const formatDate = (
  date?: string,
  formatter?: Intl.DateTimeFormat,
): string => {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  if (formatter) {
    return formatter.format(parsedDate);
  }

  return DEFAULT_DATE_FORMATTER.format(parsedDate).replace(",", "");
};
